<template>
  <div class="common">
    <a-form-model
      ref="ruleForm"
      :model="pageData"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
    >
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="登录名" prop="loginName">
            <a-input
              v-model="pageData.loginName"
              :disabled="
                modalData.type != 'create' || modalData.type == 'detail'
              "
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="登录密码"
            prop="password"
            v-if="modalData.type == 'create'"
          >
            <a-input v-model="pageData.password" type="password" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="密码确认"
            prop="repassword"
            v-if="modalData.type == 'create'"
          >
            <a-input v-model="pageData.repassword" type="password" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="姓名" prop="userName">
            <a-input
              v-model="pageData.userName"
              :disabled="
                modalData.type != 'create' || modalData.type == 'detail'
              "
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="身份证号" prop="idCardNum">
            <a-input
              v-model="pageData.idCardNum"
              :disabled="
                modalData.type != 'create' || modalData.type == 'detail'
              "
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="部门" prop="department">
            <a-input
              v-model="pageData.department"
              :disabled="modalData.type == 'detail'"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="手机号码" prop="mobile">
            <a-input
              v-model="pageData.mobile"
              :disabled="
                modalData.type != 'create' || modalData.type == 'detail'
              "
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="电子邮箱" prop="email">
            <a-input
              v-model="pageData.email"
              :disabled="
                modalData.type != 'create' || modalData.type == 'detail'
              "
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="状态" prop="isEnable">
            <a-select
              v-model="pageData.isEnable"
              :disabled="
                (modalData.type != 'create' &&
                  pageData.roleCode.indexOf('ROLE0000') > -1) ||
                  modalData.type == 'detail'
              "
            >
              <a-select-option value="1">启用</a-select-option>
              <a-select-option value="2">停用</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            label="备注"
            prop="remark"
            v-if="modalData.type != 'detail'"
          >
            <a-input
              v-model="pageData.remark"
              :disabled="modalData.type == 'detail'"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="用户角色" prop="roleCode">
            <a-checkbox-group
              v-model="pageData.roleCode"
              @change="roleChange"
              v-if=" $store.getters['home/getUserObj'].multiRole == 0"
            >
              <div v-for="item in characterOptions" :key="item.value" style="margin-top:8px;">
                <a-checkbox
                  :value="item.value"
                  name="roleCode"
                  :checked="item.checked"
                  :disabled="item.disabled || modalData.type == 'detail'"
                >
                  {{ item.name }}
                </a-checkbox>
                <!-- 用户身份为核心企业展示复核员多级 -->
                <template v-if="item.value == 'ROLE0002' && roleLevelOptions.length > 0 && isCoreCstRes">
                  <a-checkbox-group v-model="roleLevelSelects" :value="roleLevelSelects" class="role-level">
                    <a-checkbox
                    v-for="(level, level_index) in roleLevelOptions"
                    :value="level.roleLevel"
                    :key="level_index"
                    name="roleLevel"
                    :disabled="modalData.type == 'detail'"
                    >
                    {{level.roleLevel}}级
                    </a-checkbox>
                  </a-checkbox-group>
                  <div class="text-color-orange role-level-tip">多级复核员适用于祺信开立，祺信开立复核以最后一级操作为准。</div>
                </template>
              </div>
            </a-checkbox-group>

            <a-radio-group v-model="pageData.roleCode" v-else style="margin-top:8px;">
              <div v-for="item in characterOptions" :key="item.value">
                <a-radio
                  :value="item.value"
                  name="roleCode"
                  :disabled="
                    item.disabled ||
                      modalData.type == 'detail' ||
                      (pageData.roleCode &&
                        pageData.roleCode.indexOf('ROLE0000') > -1 &&
                        $store.getters['home/getUserObj'].multiRole == '1')
                  "
                >
                  {{ item.name }}
                </a-radio>
                <!-- 用户身份为核心企业展示复核员多级 -->
                <template v-if="item.value == 'ROLE0002' && roleLevelOptions.length > 0 && isCoreCstRes">
                  <a-checkbox-group :value="roleLevelSelects" v-model="roleLevelSelects" class="role-level">
                    <a-checkbox
                    v-for="(level, level_index) in roleLevelOptions"
                    :value="level.roleLevel"
                    :key="level_index"
                    name="roleLevel"
                    :disabled="modalData.type == 'detail'"
                    >
                      {{level.roleLevel}}级
                    </a-checkbox>
                  </a-checkbox-group>
                </template>
              </div>
            </a-radio-group>
            <span v-show="roleWarn" class="input-warn text-color-orange"
              >注意:1个用户拥有多个角色可能存在风险</span
            >
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import { roleApi, saveUserApi, updateUserApi } from "@/api/role.js";
import { queryRule, queryUserRel, isCoreCst } from "@/api/issueReview.js"
export default {
  props: ["modalData", "parentObj"],
  name: "userCreateModal",
  components: {},
  data() {
    return {
      modalDataAll: this.utils.deepClone(this.modalData),
      characterOptions: [],
      pageData: {
        loginName: "",
        password: "",
        repassword: "",
        userName: "",
        idCardNum: "",
        department: "",
        mobile: "",
        email: "",
        isEnable: "",
        roleCode: [],
        remark: ""
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 18 },
      rules: {
        loginName: [
          {
            required: true,
            message: "请填写登录名",
            trigger: "blur",
            whitespace: true
          }
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (this.modalData.type == "edit") {
                cbfn();
              }
              if (!value) {
                cbfn("请填写登录密码");
              } else if (!this.utils.regExpObj.PASSWORD_PATTERN.test(value)) {
                cbfn("字母/数字/特殊字符(~!@#$%^&*()_.)中至少两种组成，8-20位");
              }
              cbfn();
            }
          }
        ],
        repassword: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (this.modalData.type == "edit") {
                cbfn();
              }
              if (!value) {
                cbfn("请填写确认密码");
              } else if (value !== this.pageData.password) {
                cbfn("两次密码输入不一致");
              } else if (!this.utils.regExpObj.PASSWORD_PATTERN.test(value)) {
                cbfn("字母/数字/特殊字符(~!@#$%^&*()_.)中至少两种组成，8-20位");
              }
              cbfn();
            }
          }
        ],
        userName: [
          {
            required: true,
            message: "请填写姓名",
            trigger: "blur"
          }
        ],
        idCardNum: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("请填写身份证号");
              } else if (!this.utils.regExpObj.IDCARD_PATTERN.test(value)) {
                cbfn("输入身份证格式不正确");
              }
              cbfn();
            }
          }
        ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("请填写手机号号");
              } else if (!this.utils.regExpObj.MOBILE_PATTERN.test(value)) {
                cbfn("输入手机号格式不正确");
              }
              cbfn();
            }
          }
        ],
        email: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, cbfn) => {
              if (!value) {
                cbfn("请填写邮箱");
              } else if (!this.utils.regExpObj.EMAIL_PATTERN.test(value)) {
                cbfn("输入邮箱格式不正确");
              }
              cbfn();
            }
          }
        ],
        roleCode: [
          {
            type: "array",
            required: true,
            // message: '请选择用户角色',
            trigger: "change",
            validator: (rule, value, cbfn) => {
              if (value.length == 0) {
                cbfn("请选择用户角色");
              }
              cbfn();
            }
          }
        ],
        isEnable: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change"
          }
        ]
      },
      roleWarn: false,
      roleLevelOptions:[],
      roleLevelSelects:[],
      issueReview:"ROLE0002", //开立复核menucode
      isCoreCstRes:false
    };
  },
  computed: {},
  methods: {
    getIsCoreCst(){
      return new Promise((resolve, reject) => {
        isCoreCst().then(res => {
          this.isCoreCstRes = res.data.coreCst;
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    },
    getRoles() {
      roleApi()
        .then(res => {
          for (const item of res.data) {
            if (
              this.modalData.type == "create" &&
              item.roleCode === "ROLE0000"
            ) {
              /* 新增 管理员项 -> 不显示 */
            } else if (
              this.modalData.type == "edit" &&
              !this.modalData.data.roleCode.includes("ROLE0000") &&
              item.roleCode === "ROLE0000"
            ) {
              /* 修改 当前是非管理员 的 管理员项 -> 不显示 */
            } else {
              this.characterOptions.push({
                value: item.roleName,
                name: item.roleName,
                value: item.roleCode,
                disabled:
                  item.roleCode === "ROLE0000"
                    ? true
                    : this.modalData.type === "detail",
                checked:
                  this.modalData.type == "edit"
                    ? this.modalData.data.roleCode.includes(item.roleCode)
                    : false
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 查询开立复核级数
    queryRule() {
      if(!this.isCoreCstRes){
        return;
      }
      queryRule({
        roleCode: this.issueReview,
        cstId: this.$store.getters["home/getUserObj"].cstIds[0]
      })
        .then(res => {
          if (res.data && res.data.length > 1) {
            this.roleLevelOptions = res.data || [];
          }
        })
    },
    // 查询用户开立复核权限
    queryUserRel(){
      if(this.modalData && this.modalData.data.bigTreeId){
        queryUserRel({
          bigTreeId: this.modalData.data.bigTreeId,
        })
          .then(res => {
            let list = res.data || [];
            this.roleLevelSelects = list.map(i => i.roleLevel)
          })
      }
    },
    roleChange(data) {
      this.roleWarn = this.pageData.roleCode.length > 1;
    },
    modalOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if(this.pageData.roleCode == this.issueReview && this.roleLevelOptions.length > 0){
            if(this.roleLevelSelects.length == 0){
              this.$message.warn("请选择复核员级数");
              return;
            }
          }

          if (this.modalData.type == "create") {
            this.saveUser();
          } else if (this.modalData.type == "edit") {
            this.updateUser();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 保存复核角色权限
    getRoleLevelList(){
      let roleLevelList = []; //多级复核的参数
      if(this.roleLevelOptions.length > 0){
        this.roleLevelOptions.forEach(i => {
          if(this.roleLevelSelects.indexOf(i.roleLevel) > -1){
            roleLevelList.push({
              roleLevel:i.roleLevel,
              roleCode:i.roleCode
            })
          }
        })
      }
      return roleLevelList;
    },
    saveUser() {
      let self = this;
      this.parentObj.confirmLoading = true;
      const params = this.utils.deepClone(this.pageData);
      params.password = this.utils.getPasswordEncryptString(params.password);
      params.repassword = params.password;
      // params.roleCode = params.roleCode.join(",");
      if (this.$store.getters["home/getUserObj"].multiRole == "1") {
      } else {
        params.roleCode = params.roleCode.join(",");
      }
      params.roleLevelList = JSON.stringify(this.getRoleLevelList());
      saveUserApi(params)
        .then(res => {
          self.$message.success("提交成功");
          self.parentObj.confirmLoading = false;
          self.refresh();
        })
        .catch(err => {
          self.parentObj.confirmLoading = false;
          // self.parentObj.refresh();
          console.log(err);
        });
    },
    updateUser() {
      let self = this;
      this.parentObj.confirmLoading = true;
      const params = this.utils.deepClone(this.pageData);
      params.password = "";
      params.repassword = "";
      if (this.$store.getters["home/getUserObj"].multiRole == "1") {
      } else {
        params.roleCode = params.roleCode.join(",");
      }

      const paramRel = {
        loginName: params.loginName,
        userName: params.userName,
        password: params.password,
        repassword: params.repassword,
        idCardNum: params.idCardNum,
        department: params.department,
        mobile: params.mobile,
        roleCode: params.roleCode,
        isEnable: params.isEnable,
        email: params.email,
        remark: params.remark,
        id: params.id,
        roleLevelList: JSON.stringify(this.getRoleLevelList())
      };
      updateUserApi(paramRel)
        .then(res => {
          self.$message.success("修改成功");
          self.parentObj.confirmLoading = false;
          self.refresh();
        })
        .catch(err => {
          self.parentObj.confirmLoading = false;
          self.parentObj.refresh();
          console.log(err);
        });
    },
    resetForm() {
      this.$refs.rulepageData.resetFields();
    }
  },
  created() {
    this.getIsCoreCst().then(res => {
      if (
        (this.modalData.data && this.modalData.type == "edit") ||
        this.modalData.type == "detail"
      ) {
        const data = this.utils.deepClone(this.modalData.data);
        if (this.$store.getters["home/getUserObj"].multiRole == "1") {
          //角色只允许单选
        } else {
          data.roleCode = (data.roleCode && data.roleCode.split(",")) || [];
        }

        data.isEnable = String(data.isEnable);
        this.pageData = data;
        this.queryUserRel();
      } else if (this.$store.getters["home/getUserObj"].multiRole == "1") {
        //角色只允许单选,新增时改变初始值
        this.pageData.roleCode = undefined;
      }

      this.getRoles();
      this.queryRule();
    })
  },
  mounted() {},
  activated() {},
  watch: {}
};
</script>
<style scoped lang="less">
.input-warn {
  position: absolute;
  bottom: -30px;
  left: 0;
  white-space: nowrap;
  font-size: 12px;
}
.role-level{
  margin-left:24px;
}
.role-level-tip{
  white-space: nowrap;
  padding-left:100px;
  margin-top:8px;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/user/user-create-modal.vue